import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';
import {
    GAEventName,
    GAEventTrigger,
    GAFlowName,
    useGoogleAnalytics,
} from '../../../utils/googleAnalytics4AssetOnboardingFlow';
import { FormStep, FormStepNavigation } from './EasyOnboardingDialog';
import { getBackButtonTrackingKey, getSkipToTelematicsTrackingKey } from './trackingKeys';
import type { AssetTypeTile, BrandTile, TelematicsTile } from './configuration/types';

interface DialogFooterProps {
    formStep: FormStep;
    handleFormStepNavigation: (goTo: FormStepNavigation) => void;
    setSelectedTelematics: (value: TelematicsTile | undefined) => void;
    selectedTelematics: TelematicsTile | undefined;
    selectedAssetType: AssetTypeTile | undefined;
    setSelectedBrand: (value: BrandTile | undefined) => void;
    selectedBrand: BrandTile | undefined;
    selectedAssetId: string | undefined;
    disableFooter?: boolean;
}
export const DialogFooter = (props: DialogFooterProps) => {
    const showPrevButton =
        props.formStep === FormStep.selectBrand ||
        (props.formStep === FormStep.selectTelematics && props.selectedAssetId === undefined);
    const showSkipBrandSelectionButton = props.formStep === FormStep.selectBrand;
    const showNextButton = props.formStep === FormStep.selectTelematics;
    const { dataLayerPush } = useGoogleAnalytics();
    const footerContent = (
        <div className='display-flex justify-content-between padding-20 bg-white border border-top-only border-color-lighter rounded-bottom'>
            {showPrevButton ? (
                <Button
                    autoTrackingKey={getBackButtonTrackingKey(
                        props.formStep,
                        props.selectedAssetType,
                        props.selectedBrand
                    )}
                    onClick={() => {
                        props.handleFormStepNavigation(FormStepNavigation.prev);
                    }}
                >
                    <span className={'rioglyph rioglyph-chevron-left'} />
                    <FormattedMessage id='intl-msg:create.back' />
                </Button>
            ) : (
                <span />
            )}
            {showSkipBrandSelectionButton && (
                <Button
                    onClick={() => {
                        props.setSelectedBrand(undefined);
                        props.handleFormStepNavigation(FormStepNavigation.next);
                    }}
                    data-cy='skip-brand-selection-button'
                    autoTrackingKey={getSkipToTelematicsTrackingKey(props.selectedAssetType)}
                >
                    <FormattedMessage id='intl-msg:create-new-dialog.directly-to-telematics' />
                </Button>
            )}
            {showNextButton && (
                <Button
                    bsStyle={Button.PRIMARY}
                    autoTrackingKey='intl-msg:create-new-dialog.next'
                    onClick={() => {
                        props.handleFormStepNavigation(FormStepNavigation.next);
                        dataLayerPush({
                            trigger: GAEventTrigger.click,
                            event: GAEventName.selectTelematics,
                            element_name: getLastSegment(props.selectedTelematics?.displayName),
                            flow_name: GAFlowName.easyOnboardingFlow,
                        });
                    }}
                >
                    <div className='padding-10'>
                        <FormattedMessage id='intl-msg:create-new-dialog.next' />
                    </div>
                    <span className={'rioglyph rioglyph-chevron-right'} />
                </Button>
            )}
        </div>
    );
    return !props.disableFooter && (showPrevButton || showSkipBrandSelectionButton || showNextButton)
        ? footerContent
        : null;
};

function getLastSegment(input: string | undefined): string {
    if (input === undefined) {
        return '';
    }
    const segments = input.split('.');
    return segments[segments.length - 1];
}
